// extracted by mini-css-extract-plugin
module.exports = {"option":"OptionSelect_option__3CIXe","desabilitar":"OptionSelect_desabilitar__1Gn8G","focado":"OptionSelect_focado__3Lbao","novo":"OptionSelect_novo__3wPMY"};